/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsnotset3Inputs */

const en_ticketspayoutsnotset3 = /** @type {(inputs: Ticketspayoutsnotset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set up yet. Only needed for paid tickets.`)
};

const de_ticketspayoutsnotset3 = /** @type {(inputs: Ticketspayoutsnotset3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht eingerichtet. Nötig nur für bezahlte Tickets.`)
};

/**
* | output |
* | --- |
* | "Not set up yet. Only needed for paid tickets." |
*
* @param {Ticketspayoutsnotset3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsnotset3 = /** @type {((inputs?: Ticketspayoutsnotset3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsnotset3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsnotset3(inputs)
	return de_ticketspayoutsnotset3(inputs)
});
export { ticketspayoutsnotset3 as "ticketsPayoutsNotSet" }